import "./memeApprovalCss.css";
import BlueToggle from "../../../common/BlueToggle";
import BlueButton from "../../../common/BlueButton/BlueButton";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const ManualApprovalDisplayLogicSettings = ({
    getSettings,
    approvalToggleLogic,
    currentMeme,
    remotelyApprovedby,
    onButtonClick,
    isApiCallInProgress,
}) => {
    const { t } = useTranslation("manualApproval");

    const [displayText, setDisplayText] = useState(false);

    let displayComponent = <></>;

    const currentDisplayMemeUrl = currentMeme ? currentMeme.url : "";
    const currentDisplayMemeId = currentMeme ? currentMeme.id : "none";
    const currentDisplayPrice = currentMeme
        ? currentMeme.price
            ? currentMeme.price + " Bits"
            : ""
        : "";
    const currentDisplayTopText = currentMeme
        ? currentMeme.topText
            ? currentMeme.topText
            : ""
        : "";
    const currentDisplayBottomText = currentMeme
        ? currentMeme.bottomText
            ? currentMeme.bottomText
            : ""
        : "";
    const currentDisplayName = currentMeme
        ? currentMeme.displayName
            ? currentMeme.displayName.toUpperCase()
            : ""
        : "";

    const toggleDisplay = (
        <>
            <BlueToggle
                title={t("manualApprovalTitle")}
                onToggle={approvalToggleLogic}
                state={getSettings().manualApproval}
            />
            <hr className="manualApprovalLine"></hr>
        </>
    );

    const toggleTextDisplay = (
        <div className="manualApprovalToggleForDisplayText">
            <BlueToggle
                title={t("manualApprovalShowTextToggle")}
                onToggle={() => setDisplayText(!displayText)}
                state={displayText}
            />
        </div>
    );

    const imageDisplayMode = (
        <div className="manualApprovalContainerImage">
            <img
                className="loadingDisplayMemeApproval"
                src={currentDisplayMemeUrl}
                alt={currentDisplayMemeId}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/imageNotFound.jpg";
                }}
            />

            <p className="manualApprovalDisplayName">{currentDisplayName}</p>
        </div>
    );

    const textDisplayMode = (
        <div className="manualApprovalContainerText">
            <p>{currentDisplayPrice} </p>
            <hr className="manualApprovalLine"></hr>
            <p>{currentDisplayTopText}</p>
            <p>{currentDisplayBottomText}</p>
            <hr className="manualApprovalLine"></hr>
            <h4>{currentDisplayName}</h4>
        </div>
    );

    const approveDenyButtonDisplay = (
        <>
            <div className="manualApprovalButtonContainer">
                <BlueButton
                    text="✓"
                    onClick={() => onButtonClick("APPROVE")}
                    isCenter={true}
                />
                <BlueButton
                    text="X"
                    onClick={() => onButtonClick("DENY")}
                    isCenter={true}
                    isDark={true}
                />
            </div>
        </>
    );

    const messageDisplayForNoMeme = (text) => {
        return (
            <>
                {toggleDisplay}
                <div className="manualApprovalContainerNoImage">
                    <p className="manualApprovalTextDisplay">{text}</p>
                </div>
            </>
        );
    };

    // Display when meme is present
    displayComponent = (
        <>
            {toggleDisplay}

            {toggleTextDisplay}

            <div className="manualApprovalTextOrImageDisplay">
                {displayText ? textDisplayMode : imageDisplayMode}
            </div>
            <br />
            {approveDenyButtonDisplay}
        </>
    );

    // Display when no meme in queue
    if (!currentMeme)
        displayComponent = messageDisplayForNoMeme(
            t("manualApprovalNoMemesAwaitApproval"),
        );

    // Display when toggled off
    if (!getSettings().manualApproval)
        displayComponent = messageDisplayForNoMeme(
            t("manualApprovalDescription"),
        );

    if (isApiCallInProgress)
        displayComponent = messageDisplayForNoMeme(
            t("manualApprovalProcessingMeme"),
        );

    if (remotelyApprovedby && !isApiCallInProgress) {
        let action = remotelyApprovedby.action
            ? remotelyApprovedby.action.toLowerCase()
            : "confused";
        const actionMessages = {
            approve: t("manualApprovalActionApprove"),
            deny: t("manualApprovalActionDeny"),
            confused: t("manualApprovalActionConfused"),
        };

        action = actionMessages[action] || actionMessages.confused;
        displayComponent = messageDisplayForNoMeme(
            t("manualApprovalMemeApprovalMessage", { action }),
        );
    }

    return displayComponent;
};

export default ManualApprovalDisplayLogicSettings;
